import { useNavigation } from "@react-navigation/native"
import { StackNavigationProp } from "@react-navigation/stack"
import { Body1, Body2, Button, KeyboardSafeAreaScrollView, useTheme } from "capsule"
import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { StyleSheet } from "react-native"

import { NewClientOnboardingNS } from "../../features/i18n/constants"
import { NewClientOnboardingParamList } from "../../features/Navigation/types"

const NewClientPatientConfirmationScreen = () => {
  const { t } = useTranslation(NewClientOnboardingNS)
  const navigation =
    useNavigation<
      StackNavigationProp<NewClientOnboardingParamList, "NewClientPatientConfirmation">
    >()

  const {
    colors: {
      surface: { background },
    },
    dimensions: { spacing },
  } = useTheme()

  const s = useMemo(
    () => ({
      container: [
        styles.container,
        {
          backgroundColor: background,
        },
      ],
      innerContent: {
        paddingVertical: spacing * 2,
        paddingHorizontal: spacing * 2,
        gap: spacing * 2,
      },
      child: {
        marginTop: spacing,
      },
    }),
    [background, spacing],
  )

  return (
    <KeyboardSafeAreaScrollView style={s.container} contentContainerStyle={s.innerContent}>
      <Body1 style={styles.bold}>{t("patientConfirmation.title")}</Body1>

      <Body1 style={styles.bold}>{t("patientConfirmation.message")}</Body1>

      <Body2>{t("patientThankYou.info")}</Body2>

      <Button
        style={s.child}
        mode="contained"
        onPress={() => navigation.navigate("NewClientPatientRecommendation")}
        testID="button_complete_request"
      >
        {t("patientConfirmation.button")}
      </Button>
    </KeyboardSafeAreaScrollView>
  )
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  bold: {
    fontWeight: "bold",
  },
})

export default NewClientPatientConfirmationScreen
